import { render, staticRenderFns } from "./ContractCreate.vue?vue&type=template&id=2aaffef8&"
import script from "./ContractCreate.vue?vue&type=script&lang=js&"
export * from "./ContractCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports